import { useTonConnectUI } from "@tonconnect/ui-react";
import clsx from "clsx";
import { Link } from "react-router-dom";
import fallbackAvatar from "../../../../../../assets/fallback_images/profileSt.webp";
import { NFTLendingIcon } from "../../../../../../pages/NFTPage/ui/components/NFTPageActivity/components/Icons/NFTLending";
import Btn from "../../../../../Btn/Btn";
import LogoutIcon from "../../../../../Icons/LogoutIcon";
import UserIcon from "../../../../../Icons/UserIcon";
import WalletIcon from "../../../../../Icons/WalletIcon";
import { LazyImg } from "../../../../../LazyImg";
import useConnectButton from "../helpers/useConnectButton";
import s from "./ConnectButton.module.scss";

interface Props {
  mainPage?: boolean;
}

export const ConnectButton: React.FC<Props> = ({ mainPage }) => {
  const {
    onClick,
    ref,
    connectButtonText,
    wallet,
    connectMenuStatus,
    userAddress,
    logoutClick,
  } = useConnectButton();
  const [tonConnectUI] = useTonConnectUI();

  return (
    <div className={clsx(s.connect, wallet && s.connected)} ref={ref}>
      <Btn
        className={clsx(mainPage && s.main)}
        height="auto"
        type="white"
        onClick={() => {
          if (!wallet) {
            tonConnectUI.openModal();
          } else {
            onClick();
          }
        }}
        padding={"0 12px"}
      >
        <WalletIcon color={mainPage ? "white" : "#0D0C21"} />
        <span
          className={clsx(s.button_text, mainPage && s.white, wallet && s.maxw)}
        >
          {connectButtonText}
        </span>
        {wallet && (
          <div className={s.img}>
            <LazyImg
              imgUrl={undefined}
              fallbackImgURL={fallbackAvatar}
              alt={"Profile avatar"}
            />
          </div>
        )}
      </Btn>
      {connectMenuStatus && wallet && (
        <div className={s.btn_drop_wrapper}>
          <div className={clsx(s.btn_drop, mainPage && s.main_drop)}>
            <Link to={`/user/${userAddress}`} className={s.btn_drop_link}>
              <UserIcon color="#0D0C21" />
              <span>Profile</span>
            </Link>
            <Link to={`/lendings`} className={s.btn_drop_link}>
              <NFTLendingIcon />
              <span>Lendings</span>
            </Link>
            <div className={s.btn_drop_link} onClick={logoutClick}>
              <LogoutIcon color="#0D0C21" />
              <span>Log Out</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
